import { createTransformKeyFrame } from './transform';

export const SPIN = 'spin';
createTransformKeyFrame(SPIN, 'rotate(0deg)', 'rotate(360deg)');
